import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

/**
 * MED RDP component: Component for processing and displaying custom tags with additional functionality
 * such as creating and closing tags, and managing study ID values.
 */
@Component({
    selector: 'ca-process-and-display-custom-tags',
    templateUrl: './MED-process-and-display-custom-tags.component.html',
    styleUrls: ['./MED-process-and-display-custom-tags.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MEDProcessAndDisplayCustomTagsComponent {
    /**
     * Array of tags to be displayed.
     */
    @Input() tags: Array<string> = [];

    /**
     * Translation key for the title of the input field.
     */
    @Input() titleKey: string;

    /**
     * Placeholder text displayed in the tag input field.
     */
    @Input() placeholder: string;

    /**
     * Indicates whether the component is used on the Files page.
     */
    @Input() isFilesPage: boolean;

    /**
     * Emits the tag to be closed when the user clicks the close button on a tag.
     */
    @Output() closeTag = new EventEmitter<string>();

    /**
     * Emits a new tag to be created when the user adds a new tag.
     */
    @Output() createTag = new EventEmitter<string>();

    /**
     * Emits the study ID value when a new one is created or updated.
     */
    @Output() createStudyId = new EventEmitter<string>();

    /**
     * Study ID value associated with the component (optional).
     */
    @Input() studyIdValue?: string;

    /**
     * Maximum number of characters to display for a tag before truncating.
     */
    truncateLimit = 50;

    /**
     * Adds a new tag and emits it via the `createTag` event.
     * @param tag - The tag to be added.
     */
    addTag(tag: string): void {
        this.createTag.emit(tag);
    }

    /**
     * Emits the tag to be closed via the `closeTag` event.
     * @param tag - The tag to be removed.
     */
    onCloseTag(tag: string): void {
        this.closeTag.emit(tag);
    }
}
